/*!
 * Copyright (c) 2026 Elevation Technologies Pte Ltd.
 * Developer: filimoni@elevationtech.com.fj
 */
import React from 'react';

export default function ContactIcon({ name }) {
  const paths = {
    phone: (
      <>
        <path d="M22 16.92v2.1a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 3.3 2 2 0 0 1 4.11 1.1h2.1a2 2 0 0 1 2 1.72c.13 1.01.36 2 .7 2.94a2 2 0 0 1-.45 2.11L7.57 8.76a16 16 0 0 0 6.67 6.67l.89-.89a2 2 0 0 1 2.11-.45c.94.34 1.93.57 2.94.7A2 2 0 0 1 22 16.92Z" />
      </>
    ),
    mail: (
      <>
        <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
        <path d="m22 7-10 6L2 7" />
      </>
    ),
    location: (
      <>
        <path d="M12 22s7-5.1 7-12a7 7 0 0 0-14 0c0 6.9 7 12 7 12Z" />
        <path d="M12 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      </>
    ),
    clock: (
      <>
        <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" />
        <path d="M12 6v6l4 2" />
      </>
    ),
    external: (
      <>
        <path d="M14 3h7v7" />
        <path d="m10 14 11-11" />
        <path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" />
      </>
    ),
    globe: (
      <>
        <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" />
        <path d="M2 12h20" />
        <path d="M12 2a15.3 15.3 0 0 1 0 20" />
        <path d="M12 2a15.3 15.3 0 0 0 0 20" />
      </>
    ),
    shield: (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
        <path d="m9 12 2 2 4-5" />
      </>
    ),
    heart: (
      <>
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z" />
      </>
    ),
    warehouse: (
      <>
        <path d="M3 21V8l9-5 9 5v13" />
        <path d="M7 21V11h10v10" />
        <path d="M7 15h10" />
        <path d="M7 18h10" />
      </>
    ),
    truck: (
      <>
        <path d="M3 7h11v9H3Z" />
        <path d="M14 10h4l3 3v3h-7Z" />
        <path d="M7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
        <path d="M17 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
      </>
    ),
    vehicle: (
      <>
        <path d="M5 17h14l-1.3-5.2A3.7 3.7 0 0 0 14.1 9H9.9a3.7 3.7 0 0 0-3.6 2.8L5 17Z" />
        <path d="M7 17v2" />
        <path d="M17 17v2" />
        <path d="M7.5 13h.01" />
        <path d="M16.5 13h.01" />
      </>
    ),
    layers: (
      <>
        <path d="m12 2 9 5-9 5-9-5 9-5Z" />
        <path d="m3 12 9 5 9-5" />
        <path d="m3 17 9 5 9-5" />
      </>
    ),
    package: (
      <>
        <path d="m21 8-9-5-9 5 9 5 9-5Z" />
        <path d="M3 8v8l9 5 9-5V8" />
        <path d="M12 13v8" />
      </>
    ),
    tracker: (
      <>
        <path d="M4 5h16v10H4Z" />
        <path d="M8 21h8" />
        <path d="M12 15v6" />
        <path d="m8 10 2 2 5-5" />
      </>
    ),
  };

  return (
    <svg className="fsf-contact-icon" aria-hidden="true" viewBox="0 0 24 24" focusable="false">
      {paths[name] || paths.location}
    </svg>
  );
}
